// Leave approval workflow (components/attendance/leave-approval.tsx, the leave tab and check-in leave list).
const EN_B21: Record<string, string> = {
  "طلبات تنتظر قرارك": "Requests awaiting your decision",
  "لا طلبات تنتظر قرارك الآن": "No requests awaiting your decision",
  "تعذّرت قراءةُ طلبات الاعتماد": "Could not load approval requests",
  "قائمةُ الاعتماد غيرُ مقروءةٍ لك": "You cannot read the approval queue",
  "تُعرض أوّلُ ٣٠٠ طلب — الباقي يظهر بعد البتّ فيها": "Showing the first 300 requests — the rest appear once these are decided",
  "معلّق — لا يستطيع أحدٌ البتَّ فيه الآن": "Blocked — nobody can decide it right now",
  "للاطّلاع": "View only",
  "أعد المحاولة": "Retry",
  "اعتماد المرحلة ١": "Approve stage 1",
  "الاعتماد النهائي": "Final approval",
  "سجلّ الطلب": "Request history",
  "لا أحداث": "No events",
  "تعذّرت قراءةُ سجلّ الطلب": "Could not load the request history",
  "إلغاء الإجازة المعتمَدة": "Cancel approved leave",
  "إلغاء إجازةٍ معتمَدة": "Cancel an approved leave",
  "سبب الإلغاء (إلزاميّ)": "Cancellation reason (required)",
  "مثال: عاد الموظّف قبل الموعد": "e.g. the employee returned early",
  "يبقى قرارُ الاعتماد الأصليّ في السجلّ كما هو، ويُضاف الإلغاءُ باسمك وسببه، ويصل الموظّفَ إشعار. لا يمكن الإلغاء إن لمس فترةَ رواتب معتمَدة أو مدفوعة أو مؤرشفة أو مُسوّاة.":
    "The original approval stays in the history; the cancellation is added with your name and reason, and the employee is notified. It is refused if it touches an approved, paid, archived or externally settled payroll period.",
  "اكتب سبباً من ٣ أحرف على الأقلّ": "Write a reason of at least 3 characters",
  "أُلغيت الإجازة": "Leave cancelled",
  "تعذّرت قراءةُ إعداد مراحل الاعتماد": "Could not read the approval-stages setting",
  "مراحل اعتماد الاستئذان": "Leave approval stages",
  "مرحلةٌ واحدة — يعتمد مشرفٌ أو مدير": "One stage — a supervisor or admin approves",
  "مرحلتان — مسؤول الفرع ثمّ معتمِدٌ نهائيّ آخر": "Two stages — branch manager, then a different final approver",
  "يسري على الطلبات الجديدة وحدَها؛ الطلباتُ القائمة تكمل بطريقتها.": "Applies to new requests only; existing requests continue as submitted.",
  "الإعدادُ المخزَّن تالف — لا يُقبل طلبٌ جديد حتى تختار وضعاً وتحفظه.": "The stored setting is invalid — no new request is accepted until you choose a mode and save.",
  "حُفظ وضعُ الاعتماد": "Approval mode saved",
  "فروعٌ بلا مسؤول (طلباتُها تبقى معلّقة في وضع المرحلتين):": "Branches without a manager (their requests stay blocked in two-stage mode):",
  "فروعٌ مسؤولُها بلا صلاحيّة الاعتماد والاطّلاع:": "Branches whose manager lacks approval and team-view permissions:",
  "عددُ المعتمِدين النهائيّين المؤهَّلين (تقديرٌ عامّ — لا يضمن معتمِداً لكلّ طلب):": "Eligible final approvers (a general count — it does not guarantee an approver for every request):",
  "المرحلة ١": "Stage 1",
  "ألغاها": "Cancelled by",
  "اعتمادٌ واحد": "Single approval",
  "المرحلة ١: مسؤول الفرع": "Stage 1: branch manager",
  "المرحلة ٢: الاعتماد النهائي": "Stage 2: final approval",
  "منتهٍ": "Closed",
  "قُدّم الطلب": "Submitted",
  "اعتُمدت المرحلة ١": "Stage 1 approved",
  "رُفض في المرحلة ١": "Rejected at stage 1",
  "اعتُمد نهائيّاً": "Final approval",
  "رُفض في الاعتماد النهائي": "Rejected at final approval",
  "أُلغيت الإجازة المعتمَدة": "Approved leave cancelled",
  "أُلغيت بعد الاعتماد": "Cancelled after approval",
  "مرحلتان": "Two stages",
  "بانتظار مسؤول الفرع (المرحلة ١)": "Waiting for the branch manager (stage 1)",
  "بانتظار الاعتماد النهائي (المرحلة ٢)": "Waiting for final approval (stage 2)",
  "اعتمد المرحلة ١": "Stage 1 approved by",
  "مسؤول الفرع": "branch manager",
  "الطلب معلّق": "Blocked",
  "يقرّره المعتمِدون بحسب إعداد شركتك، ويصلك القرارُ هنا. والطلبُ لا يُحذف — يبقى بقراره في القائمة أدناه.":
    "Approvers decide it according to your company's setting, and the decision appears here. Requests are never deleted — each stays in the list below with its decision.",
};
export default EN_B21;
